import { Fragment, useCallback } from 'react';
import { connect } from 'react-redux';

import { ApplicantServices } from 'src/components/ApplicantServices/common';
import ResumeUpdate from 'src/components/ResumeUpdate';
import translation from 'src/components/translation';
import { resumeUpdatedAction, resumeSetToUpdateValueAction } from 'src/models/resume';

import ResumeRenewalButton from 'src/pages/ResumeView/components/View/ResumeSidebar/ResumeRenewalButton';
import ResumeUpdateView from 'src/pages/ResumeView/components/View/ResumeSidebar/ResumeUpdateView';

const ResumeSidebarUpdate = ({
    hash,
    humanDatesRules,
    renewal,
    setResumeUpdated,
    setResumeToUpdateValue,
    showUpdateBlock,
    timeLeft,
    isRenewalAvailable,
    trls,
    updateInterval,
}) => {
    const onUpdate = useCallback(
        (updated) => {
            setResumeUpdated({ updated });
            setResumeToUpdateValue({ value: updateInterval / 1000 });
        },
        [setResumeToUpdateValue, setResumeUpdated, updateInterval]
    );

    if (renewal) {
        return <div className="resume-sidebar-link">{trls[ResumeSidebarUpdate.trls.automatic]}</div>;
    }

    return showUpdateBlock ? (
        <Fragment>
            <ResumeUpdate
                hash={hash}
                humanDatesRules={humanDatesRules}
                onUpdate={onUpdate}
                RenderComponent={ResumeUpdateView}
                timeLeft={timeLeft}
                updateInterval={updateInterval}
                isRenewalAvailable={isRenewalAvailable}
            />
            <ResumeRenewalButton hash={hash} />
        </Fragment>
    ) : null;
};

ResumeSidebarUpdate.trls = {
    automatic: 'rb.publish.isautomatic',
};

export default connect(
    (state) => ({
        hash: state.resume?.hash,
        humanDatesRules: state.resume?.humanDatesRules,
        renewal: state.resume?.renewal,
        showUpdateBlock: state.resume?.showUpdateBlock,
        timeLeft: state.resume?.toUpdate.value * 1000,
        updateInterval: state.resume?.updateTimeout,
        isRenewalAvailable: state.applicantPaymentServices.includes(ApplicantServices.ResumeRenewal),
    }),
    {
        setResumeUpdated: resumeUpdatedAction,
        setResumeToUpdateValue: resumeSetToUpdateValueAction,
    }
)(translation(ResumeSidebarUpdate));
